import { Typography } from "@mui/material";
import { CoreDragAndDropIcon, CoreFileCard, FileCardError, type CoreFileItem, CoreUpload } from "../../core";
import i18nPackage from "../../i18n/i18n";
import { BasicStep } from "../components/basic-step";
import styles from "./index.module.css";

type ReferenceMaterialUploadSubstepProps = {
	file?: CoreFileItem;
	onUpload: (files: File[]) => void;
	onRemove: () => void;
	fileTypes: string;
	errorMessage?: string;
};

export function ReferenceMaterialUploadSubstep({
	file,
	onUpload,
	onRemove,
	fileTypes,
	errorMessage,
}: ReferenceMaterialUploadSubstepProps) {
	return (
		<div className={styles.referenceMaterialUploadCard}>
			<div className={styles.referenceMaterialUploadGrid}>
				<div className={styles.referenceMaterialUploadInfo}>
					<Typography variant="h2" className={styles.referenceMaterialUploadTitle}>
						{i18nPackage.t("beforeQuiz.referenceMaterial.uploadTitle")}{" "}
						<span className={styles.referenceMaterialOptional}>
							{i18nPackage.t("beforeQuiz.referenceMaterial.optional")}
						</span>
					</Typography>
					<Typography className={styles.referenceMaterialUploadCaption}>
						{i18nPackage.t("beforeQuiz.referenceMaterial.uploadCaption")}
					</Typography>
				</div>
				<div className={styles.referenceMaterialUploadZone}>
					{!file ? (
						<div className={styles.referenceMaterialUploadZoneContent}>
							<CoreUpload onUpload={onUpload} fileTypes={fileTypes} className={styles.referenceMaterialUpload}>
								{(open) => (
									<div className={styles.referenceMaterialUploadContent}>
										<div className={styles.referenceMaterialUploadIconCircle}>
											<CoreDragAndDropIcon />
										</div>
										<div className={styles.referenceMaterialUploadActionRow}>
											<button type="button" className={styles.referenceMaterialChooseFileLink} onClick={open}>
												{i18nPackage.t("beforeQuiz.referenceMaterial.chooseFile")}
											</button>
											<span>{i18nPackage.t("beforeQuiz.referenceMaterial.toUpload")}</span>
										</div>
									</div>
								)}
							</CoreUpload>
							{errorMessage && <FileCardError message={errorMessage} className={styles.referenceMaterialUploadError} />}
						</div>
					) : (
						<div className={styles.referenceMaterialFileList}>
							<div className={styles.referenceMaterialFileItem}>
								<CoreFileCard file={file} onRemove={onRemove} showOpenInNewTab errorMessage={errorMessage}/>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default function ReferenceMaterialStep({ children }: { children: React.ReactNode }) {
	return <BasicStep description={i18nPackage.t("beforeQuiz.referenceMaterial.description")}>{children}</BasicStep>;
}
